import * as ToastPrimitive from "@radix-ui/react-toast";
import { MdCheckCircle, MdWarning, MdError } from "react-icons/md";
import { toastStore } from "@/store/toastStore";
import { ToastItem } from "@/types/toast";
import styles from "./Toast.module.scss";

type Props = {
	value: ToastItem;
};

/**
 * トースト コンポーネント
 * @param props props
 * @returns トーストコンポーネント
 */
export default function Toast(props: Props) {
	const { value } = props;
	const { closeToast } = toastStore();

	return (
		<ToastPrimitive.Root
			open={value.isOpen}
			onOpenChange={(isOpen) => !isOpen && closeToast(value.id)}
			duration={value.duration}
			className={styles.toastRoot}
			onClick={() => closeToast(value.id)}
		>
			{value.type === "success" && (
				<MdCheckCircle className={styles.success} />
			)}
			{value.type === "warning" && (
				<MdWarning className={styles.warning} />
			)}
			{value.type === "error" && <MdError className={styles.error} />}

			<div>
				<ToastPrimitive.Title className={styles.toastTitle}>
					{value.title}
				</ToastPrimitive.Title>
				{value.description && (
					<ToastPrimitive.Description
						className={styles.ToastDescription}
					>
						{value.description}
					</ToastPrimitive.Description>
				)}
			</div>
			{/* <ToastPrimitive.Close><MdClose /></ToastPrimitive.Close> */}
		</ToastPrimitive.Root>
	);
}
